import { useQuery } from "@tanstack/react-query"

/**
 * Vorschlag fuer Kontakt + Vorgang einer Aufgabe, die jemand von Hand aus
 * einer Mail anlegt (#108).
 *
 * „Projekte sollten auch bei ‚manueller' Aufgabenanlage automatisch verknüpft
 * sein" (Paul, 17.09.2026). Prod, KW 38: 30 von 36 Handaufgaben ohne Projekt,
 * keine mit Kontakt — die Dialoge belegten nichts vor, obwohl der Plan zur
 * selben Mail beides oft schon kannte.
 *
 * 🔴 Die REGEL liegt auf dem Server (`services/aufgabe_verknuepfung.py`), hier
 * wird nur abgeholt. Es gibt zwei Dialoge, die aus einer Mail eine Aufgabe
 * machen (Posteingang: CallTaskModal, Review: CreateTaskModal) — eine Regel
 * je Dialog liefe auseinander, wie schon bei #41 und #22. Neuer Dialog?
 * Diesen Hook benutzen.
 */
export type VerknuepfungKontakt = {
  id: number; name: string; quelle: string; herkunft: string; vermutlich: boolean
}
export type VerknuepfungVorgang = {
  id: number; bezeichnung: string; status: string; quelle: string; herkunft: string; vermutlich: boolean
}
export type AufgabeVerknuepfung = {
  contact: VerknuepfungKontakt | null
  project: VerknuepfungVorgang | null
}

export function useAufgabeVerknuepfung(emailId: number | string | null | undefined, aktiv: boolean) {
  return useQuery<AufgabeVerknuepfung>({
    queryKey: ["aufgabe-verknuepfung", String(emailId ?? "")],
    queryFn: async () => {
      const r = await fetch(`/api/v1/emails/${emailId}/aufgabe-verknuepfung`, { credentials: "include" })
      // Ohne Vorschlag bleibt der Dialog, wie er war — kein Fehler fuer den Nutzer.
      if (!r.ok) return { contact: null, project: null }
      return r.json()
    },
    enabled: aktiv && !!emailId,
    staleTime: 0,
  })
}

/** „vom Plan erkannt" bzw. „vermutlich — Firmendomain des Absenders · bitte prüfen" */
export function herkunftHinweis(v: { herkunft: string; vermutlich: boolean } | null | undefined): string {
  if (!v) return ""
  return v.vermutlich ? `vermutlich — ${v.herkunft} · bitte prüfen` : `automatisch: ${v.herkunft}`
}
